<ng-template #shopImagesTemplate>
  @if (isBrowser) {
    <div class="p-2 px-lg-0 py-lg-2 shop-images d-flex flex-wrap" style="display: flex; flex-wrap: wrap">
      @for (topshopImage of shopImages; track topshopImage.big; let additionalImagePathIndex = $index) {
        @if (additionalImagePathIndex !== 0 || isSmallerThanLargeDevice) {
          <div
            data-test="topShopImage"
            class="d-flex align-items-center"
            [class.active]="additionalImagePathIndex === shopImageIndex"
            (mousemove)="updateImagePosition($event)"
            (mouseleave)="onMouseLeave($event)"
            (click)="openImageSlider(additionalImagePathIndex)">
            <picture>
              <source
                [srcset]="topshopImage.small.replace('.jpg', '.webp') | platformurl"
                type="image/webp" />
              <source [srcset]="topshopImage.small | platformurl" type="image/jpg" />
              <img
                class="product__top-shop-small-image"
                [loading]="shop.position === 0 ? 'eager' : 'lazy'"
                src="{{ topshopImage.small | platformurl }}"
                width="204"
                height="136"
                alt="Top Shop Image"
                style="opacity: 1"
                (error)="removeAdditionalImage(additionalImagePathIndex)" />
            </picture>
            @if (!isSmallerThanLargeDevice) {
              <picture class="product__top-shop-large-image" style="display: none; left: 551px; top: 243px">
                <source
                  [srcset]="topshopImage.big.replace('.jpg', '.webp') | platformurl"
                  type="image/webp" />
                <source [srcset]="topshopImage.big | platformurl" type="image/jpeg" />
                <img
                  alt="Top Shop Image"
                  src="{{ topshopImage.big | platformurl }}"
                  (error)="errorShopImage(additionalImagePathIndex)" />
              </picture>
            }
          </div>
        }
      }
    </div>
  }
</ng-template>
<div class="town-card d-flex p-lg-2">
  <div class="row w-100 ml-0 mr-0" style="display: flex; flex-wrap: wrap">
    <!-- image with top shop / discount / trusted shop flags -->
    <div class="col-6 col-sm-6 col-lg-4 pl-0 col-image d-flex flex-column">
      @if (isSmallerThanLargeDevice) {
        <a
          target="_blank"
          style="display: block"
          class="flex-grow-1"
          [href]="productLink"
          (click)="validationAndSubmit($event)">
          @if (isBrowser || shop.lazyshow) {
            <div class="image-wrapper h-100">
              @for (image of shopImages; track image.big; let i = $index) {
                @if (i === shopImageIndex) {
                  <picture>
                    <source
                      srcset="{{ image.bigWebP | platformurl }}"
                      width="600"
                      height="400"
                      type="image/webp" />
                    <source
                      srcset="{{ image.big | platformurl }}"
                      width="600"
                      height="400"
                      type="image/jpeg" />
                    <img
                      [attr.fetchpriority]="this.shop.position === 0 ? 'high' : 'auto'"
                      alt="{{ shop.name }}"
                      aria-hidden="true"
                      width="600"
                      height="400"
                      src="{{ image.big | platformurl }}"
                      (error)="errorShopImage(i)"
                      (touchstart)="touchStartMobile($event)"
                      (touchend)="touchEndMobile($event)" />
                  </picture>
                }
              }
              <div class="w-100"></div>
              @if (isBrowser && !isPartner && shop.companyLogoSmall && currentPlatformShortcode === 'ar') {
                <div class="logo-wrapper">
                  <img
                    [loading]="shop.position === 0 ? 'eager' : 'lazy'"
                    [src]="shop.companyLogoSmall | platformurl"
                    class="logo"
                    alt=""
                    height="32"
                    width="277" />
                </div>
              }
              @if (isBrowser && !isPartner && currentPlatformShortcode === 'es' && +shop.companyId === 19) {
                <div class="logo-wrapper">
                  <img
                    [src]="'companyLogos/ekosport.png' | platformasset: true"
                    class="logo"
                    width="733"
                    height="121"
                    alt="ekosport-rent.com" />
                </div>
              }
              @if (shop.isTopShop) {
                <div class="image-label text-uppercase">Top shop</div>
              } @else if (shop.isDiscountShop) {
                <div class="image-label bg-danger text-uppercase">Best price</div>
              } @else if (shop.isVirtualShop) {
                <div class="image-label text-uppercase">
                  @if (shop.vsLocationDropOff) {
                    <app-icon name="box" style="vertical-align: -3px" />
                    Delivery
                  } @else {
                    <app-icon name="delivery" style="vertical-align: -3px" />
                    {{ shop.vsEquipmentToLocation ? 'Delivery' : 'Shuttle service' }}
                  }
                </div>
              }
            </div>
          } @else {
            <div class="d-flex h-100 image-wrapper"></div>
          }
        </a>
        @if (shopImages?.length > 1) {
          <ng-container *ngTemplateOutlet="shopImagesTemplate"></ng-container>
        }
        <!-- desktop view -->
      } @else {
        <a class="flex-grow-1" [href]="shopLink" target="_blank">
          <div class="h-100 image-wrapper">
            <picture class="d-flex h-100 w-100 justify-content-center align-items-center">
              <source
                srcset="{{ shopImages[0] ? (shopImages[0].bigWebP | platformurl) : '' }}"
                width="600"
                height="400"
                type="image/webp" />
              <source
                srcset="{{ shopImages[0] ? (shopImages[0].big | platformurl) : '' }}"
                width="600"
                height="400"
                type="image/jpeg" />
              <img
                alt="{{ shop.name }}"
                width="600"
                height="400"
                aria-hidden="true"
                src="{{ shopImages[0] ? (shopImages[0].big | platformurl) : '' }}"
                (error)="errorShopImage(0)" />
            </picture>
            <div class="w-100"></div>
            @if (
              shop.companyLogoSmall &&
              isBrowser &&
              !isPartner &&
              showAdditionalElements &&
              currentPlatformShortcode === 'ar'
            ) {
              <div class="logo-wrapper">
                <img [src]="shop.companyLogoSmall | platformurl" class="logo" alt="" />
              </div>
            }
            @if (
              isBrowser &&
              !isPartner &&
              showAdditionalElements &&
              currentPlatformShortcode === 'es' &&
              +shop.companyId === 19
            ) {
              <div class="logo-wrapper">
                <img
                  [src]="'companyLogos/ekosport.png' | platformasset: true"
                  class="logo"
                  alt="ekosport-rent.com" />
              </div>
            }
            <!-- desktop -->
            @if (shop.isTopShop) {
              <div class="image-label text-uppercase">Top shop</div>
            } @else if (shop.isDiscountShop) {
              <div class="image-label bg-danger text-uppercase">Best price</div>
            } @else if (shop.isVirtualShop) {
              <div class="image-label text-uppercase">
                @if (shop.vsLocationDropOff) {
                  <app-icon name="box" style="vertical-align: -3px" />
                  Delivery
                } @else {
                  <app-icon name="delivery" style="vertical-align: -3px" />
                  {{ shop.vsEquipmentToLocation ? 'Delivery' : 'Shuttle service' }}
                }
              </div>
            }
          </div>
        </a>
      }
    </div>
    <!-- image with top shop / discount / trusted shop flags end -->

    <div class="town-card-content-wrapper col-6 col-sm-6 col-lg-8 pl-sm-0 pr-0">
      @if (shop.hasDiscountCountdown && !isPartner) {
        <div class="count-down-wrapper d-none d-md-block">
          <!--  <app-discountticker [timestamp]="shop.timestamp"/> -->
        </div>
      }
      <div class="row d-flex no-gutters pt-1 h-100">
        <!-- left half with shop image, address and benefits -->
        <div class="col-12 col-lg-5 d-flex flex-column">
          <div class="shop-details-wrapper p-2 p-lg-0 d-flex flex-column">
            <div class="shop-title">
              @if (isSmallerThanLargeDevice) {
                <!-- mobile links point to PS -->
                <a
                  class="d-lg-none"
                  data-test="shopTitleLink"
                  target="_blank"
                  [href]="productLink"
                  (click)="validationAndSubmit($event)">
                  {{ shop.name }}
                </a>
              } @else {
                <!-- desktop links point either to PS or Shop page (shopNavToPS test) -->
                <a data-test="shopTitleLink" [href]="shopLink" target="_blank">
                  {{ shop.name }}
                </a>
              }
            </div>
            <div class="address">
              @if (shop.isVirtualShop) {
                {{ 'SHOP.virtualAddress' | alpitranslate: { shopname: shop.name, placename: shop.townName } }}
              } @else {
                {{ shop.address }}
              }
            </div>
            <div
              data-test="shopShowOnMap"
              class="map-link d-flex align-items-center"
              (click)="showOnMap($event)">
              <app-icon name="place" class="text-danger mr-1" width="14px" height="14px" />
              <span>{{ 'SHOP.showOnMap' | alpitranslate }}</span>
            </div>
            @if (sortBy === 'hotel' && shop.hotelDistance) {
              @defer (when shop.hotelDistance) {
                <div class="distance-hint">
                  <app-distance-display
                    [distanceMeter]="shop.hotelDistance.distanceMeters"
                    [distanceSeconds]="shop.hotelDistance.distanceSeconds"
                    [distanceMeterCar]="shop.hotelDistance.distanceMetersCar"
                    [distanceSecondsCar]="shop.hotelDistance.distanceSecondsCar"
                    [type]="shop.shopType" />
                </div>
              }
            } @else if (shop.distance >= 2 && shop.inTown === false && showDistanceBadge) {
              <div class="distance-hint">
                {{ 'SHOP.airDistance' | alpitranslate: { distance: shop.distance | number: '1.0-0' } }}
              </div>
            }
          </div>
          @if (!isSmallerThanLargeDevice && shopImages?.length > 1) {
            <ng-container *ngTemplateOutlet="shopImagesTemplate"></ng-container>
          }
          @if (!isBrowser && shopImages.length > 1) {
            <div class="px-2 px-lg-0 py-lg-2 shop-images d-flex flex-wrap">
              <div class="product__top-shop-small-image"></div>
            </div>
          }
          <div class="store-benefits mt-auto pt-3">
            <div
              data-test="openMobileOffers"
              class="title mb-1 d-flex flex-row align-items-center"
              (click)="toggleMobileOffers()">
              <div class="mr-1">{{ 'SHOP.benefits' | alpitranslate }}:</div>
              <div class="text-primary ml-auto d-block d-lg-none">
                <app-icon name="discountArrow" class="icon-arrow" [class.open]="openedMobileOffers" />
              </div>
            </div>
            <ul
              class="benefit-list"
              [@collapsibleToggle]="openedMobileOffers || !isSmallerThanLargeDevice ? 'in' : 'out'">
              @if (shop.isTopShop) {
                <li data-test="topShopTooltipHoverElement" [appTooltip]="isTopShopTipContent">
                  <ng-template #isTopShopTipContent>
                    <strong>
                      {{ 'SHOP.productFeatureTopShop' | alpitranslate }}
                    </strong>
                    <ul class="tooltip-list" data-test="topShopTooltip">
                      @for (property of translatedProperties; track property) {
                        <li class="mb-1">
                          <app-icon name="snowBullet2" class="mr-1" />
                          {{ property }}
                        </li>
                      }
                    </ul>
                  </ng-template>
                  <app-icon name="topShop" class="mr-1" />
                  {{ 'SHOP.productFeatureTopShop' | alpitranslate }}
                </li>
              }
              @if (shop.isDiscountShop) {
                <li data-test="discountShopTooltipHoverElement" [appTooltip]="toolTipDiscountShopTemplate">
                  <ng-template #toolTipDiscountShopTemplate>
                    <strong>
                      {{ 'SHOP.productFeatureDiscountShop' | alpitranslate }}
                    </strong>
                    <ul class="tooltip-list" data-test="discountShopTooltip">
                      @for (property of translatedProperties; track property) {
                        <li class="mb-1">
                          <app-icon name="snowBullet2" class="mr-1" />
                          {{ property }}
                        </li>
                      }
                    </ul>
                  </ng-template>
                  <app-icon name="discount" class="mr-1" />
                  {{ 'SHOP.productFeatureDiscountShop' | alpitranslate }}
                </li>
              }
              @if (shop.isVirtualShop) {
                @if (shop.vsLocationDropOff) {
                  <li
                    data-test="deliveryDropOffTooltipHoverElement"
                    [appTooltip]="toolTipDropOffShopTemplate">
                    <ng-template #toolTipDropOffShopTemplate>
                      <strong>
                        {{ 'SHOP.productFeatureDelivery' | alpitranslate }}
                      </strong>
                      <ul class="tooltip-list" data-test="deliveryShopTooltipDropOff">
                        <li>
                          {{ 'SHOP.productFeatureDeliveryTooltipDropOff' | alpitranslate }}
                        </li>
                      </ul>
                    </ng-template>
                    <app-icon name="box" class="mr-1" />
                    {{ 'SHOP.productFeatureDelivery' | alpitranslate }}
                  </li>
                } @else {
                  <li data-test="deliveryTooltipHoverElement" [appTooltip]="toolTipVirtualShopTemplate">
                    <ng-template #toolTipVirtualShopTemplate>
                      <strong>
                        {{
                          shop.vsEquipmentToLocation
                            ? ('SHOP.productFeatureDelivery' | alpitranslate)
                            : 'Shuttle Service'
                        }}
                      </strong>
                      <ul class="tooltip-list" data-test="deliveryShopTooltip">
                        @if (shop.vsEquipmentToLocation) {
                          <li>
                            {{
                              'SHOP.productFeatureDeliveryTooltipDelivery'
                                | alpitranslate: { shopname: shop.name }
                            }}
                          </li>
                        } @else {
                          <li>
                            {{
                              'SHOP.productFeatureDeliveryTooltipPickup'
                                | alpitranslate: { shopname: shop.name }
                            }}
                          </li>
                        }
                      </ul>
                    </ng-template>
                    <app-icon name="delivery" class="mr-1" />
                    @if (shop.vsEquipmentToLocation) {
                      {{ 'SHOP.productFeatureDelivery' | alpitranslate }}
                    } @else {
                      Shuttle Service
                    }
                  </li>
                }
              }
              @if (shop.hasFreeChildren) {
                <li
                  data-test="freeChildrenShopTooltipHoverElement"
                  [appTooltip]="toolTipHasFreeChildrenTemplate">
                  <ng-template #toolTipHasFreeChildrenTemplate>
                    <strong>{{ 'SHOP.productFeatureOneChildFree' | alpitranslate }}</strong>
                    <div data-test="freeChildrenShopTooltip" class="text-left">
                      {{
                        'SHOP.productFeatureOneChild.tooltip'
                          | alpitranslate
                            : {
                                pluralizeAdult:
                                  'SHOP.productFeatureOneChild.adult'
                                  | alpitranslate: { pluralate: shop.requiredAdultsForFreeChildren },
                                pluralizeChildren:
                                  'SHOP.productFeatureOneChild.child'
                                  | alpitranslate: { pluralate: shop.freeChildrenPerAdults },
                                age_child:
                                  'SHOP.productFeatureOneChild.year'
                                  | alpitranslate: { pluralate: shop.childrenFreeUntilAge }
                              }
                      }}
                    </div>
                  </ng-template>
                  <app-icon name="smChild" class="mr-1" />
                  {{ 'SHOP.productFeatureOneChildFree' | alpitranslate }}
                </li>
              }
              @if (shop.hasGuaranty && !['cs', 'sk'].includes(currentLang)) {
                <li
                  data-test="damageGuaranteShopTooltipHoverElement"
                  [appTooltip]="toolTipHasGuarantyTemplate">
                  <ng-template #toolTipHasGuarantyTemplate>
                    <strong>{{ 'SHOP.productFeatureInsurance' | alpitranslate }}</strong>
                    <ul class="tooltip-list" data-test="damageGuaranteShopTooltip">
                      <li>
                        {{
                          (isPartner
                            ? 'SHOP.productFeatureMicrositeInsuranceTooltip'
                            : 'SHOP.productFeatureInsuranceTooltip'
                          ) | alpitranslate
                        }}
                      </li>
                    </ul>
                  </ng-template>
                  <app-icon name="damage" class="mr-1" />
                  {{ 'SHOP.productFeatureInsurance' | alpitranslate }}
                </li>
              }
              @if (shop.hasDepot) {
                <li data-test="depotShopTooltipHoverElement" [appTooltip]="toolTipHasDepotTemplate">
                  <ng-template #toolTipHasDepotTemplate>
                    <strong>{{ 'SHOP.productFeatureDepot' | alpitranslate }}</strong>
                    <ul class="tooltip-list" data-test="depotShopTooltip">
                      <li>{{ 'SHOP.productFeatureDepotTooltip' | alpitranslate }}</li>
                    </ul>
                  </ng-template>
                  <app-icon name="depot" class="mr-1" />
                  {{ 'SHOP.productFeatureDepot' | alpitranslate }}
                </li>
              }
              @if (shop.hasModelChange) {
                <li
                  data-test="changeEquipmnetShopTooltipHoverElement"
                  [appTooltip]="toolTipHasModelChangeTemplate">
                  <ng-template #toolTipHasModelChangeTemplate>
                    <strong>{{ 'SHOP.productFeatureItemChange' | alpitranslate }}</strong>
                    <ul class="tooltip-list" data-test="changeEquipmnetShopTooltip">
                      <li>{{ 'SHOP.productFeatureItemChangeTooltip' | alpitranslate }}</li>
                    </ul>
                  </ng-template>
                  <app-icon name="changeEquipment" class="mr-1" />
                  {{ 'SHOP.productFeatureItemChange' | alpitranslate }}
                </li>
              }
            </ul>
          </div>
        </div>
        <!-- left half with shop image, address and benefits end -->
        <!-- right half with offers and continue button -->
        <div
          class="col-12 col-lg-7 pl-lg-3 d-flex flex-column"
          [class.active-count-down]="shop.hasDiscountCountdown">
          <div class="special-info-wrapper">
            <div class="special-offer-title mb-2 text-uppercase">
              {{ 'SHOP.discountPromotionHeader' | alpitranslate }}
            </div>
            <ul class="special-offer-list">
              <!-- group offer text -->
              @if (showGroupBookingTestCondition) {
                @for (promotion of shop.discountPromotions?.group; track promotion.criterion) {
                  <li>
                    <app-icon name="discount" class="offer-icon flex-shrink-0" />
                    <small>{{
                      'SHOP.groupDiscountText'
                        | alpitranslate
                          : { person_count: promotion.criterion, percentage: promotion.percentage | percent }
                    }}</small>
                  </li>
                }
              }
              <!-- group offer text end -->
              <!-- free children offer text-->
              @if (shop.hasFreeChildren) {
                <li>
                  <app-icon name="freeChildAdult" class="offer-icon flex-shrink-0" />
                  <small>
                    {{
                      'SHOP.childrenFree.text'
                        | alpitranslate
                          : {
                              pluralizeAdult:
                                'SHOP.childrenFree.adult'
                                | alpitranslate: { pluralate: shop.requiredAdultsForFreeChildren },
                              pluralizeChildren:
                                'SHOP.childrenFree.child'
                                | alpitranslate: { pluralate: shop.freeChildrenPerAdults },
                              age_child:
                                'SHOP.childrenFree.year'
                                | alpitranslate: { pluralate: shop.childrenFreeUntilAge }
                            }
                    }}
                  </small>
                </li>
              }
              <!-- freeFlexi text -->
              @if (showAlpinFlexiBadge) {
                <li class="info align-items-center" [appTooltip]="toolTipAlpinFlexiBadgeTemplate">
                  <app-icon name="reserve" class="offer-icon flex-shrink-0" />
                  <span [innerHTML]="'SHOP.flexiBadge' | alpitranslate"></span>
                  <ng-template #toolTipAlpinFlexiBadgeTemplate>
                    <!-- <div style="pointer-events: auto" class="alpi-tooltip">
                       <app-icon name="cross" class="ml-2 d-block d-sm-none" (click)="alpinFlexiTooltip.close()" />
                       <div class="content">
                         <span class="alpi-tooltip-inner flexiBadge"> -->
                    {{
                      'SHOP.flexiBadgeTooltip'
                        | alpitranslate
                          : {
                              to_date: freeFlexiUntil | date: ('SHOP.freeStornoDateFormat' | alpitranslate),
                              cancellationInsuranceName: cancellationInsuranceName
                            }
                    }}
                    <!-- </span>
                       </div>
                     </div> -->
                  </ng-template>
                  <app-icon name="infoCircle" class="small ml-1" />
                </li>
              }
            </ul>
          </div>
          @if (shop.vsLocationDropOff) {
            @defer (when shop.vsLocationDropOff) {
              <app-vs-location-drop-off-advantages [companyName]="shop.companyName" />
            }
          }
          <div class="count-down-wrapper">
            <div #discountTickerAnchor></div>
          </div>
          @if (!this.resolutionService.isMobileDevice()) {
            <ng-container [ngTemplateOutlet]="proceedButton"></ng-container>
          }
          <!-- CONTINUE Button end -->
          <!-- continue button OR unbookable OR please search before continue -->
        </div>
        <!-- right half with offers and continue button end -->
      </div>
    </div>
    <div class="d-md-none w-100" style="width: 100%">
      @if (this.resolutionService.isMobileDevice()) {
        <ng-container [ngTemplateOutlet]="proceedButton"></ng-container>
      }
    </div>
  </div>
</div>

<ng-template #proceedButton>
  @if (shop.primaryUnbookableReasonFor(bookingParameters.start, bookingParameters.end) !== null) {
    @defer (when shop.primaryUnbookableReasonFor(bookingParameters.start, bookingParameters.end) !== null) {
      <app-unbookable-info
        class="px-2 pb-2 p-lg-0 d-flex align-items-center"
        [class.flex-grow-1]="this.resolutionService.isMobileDevice()"
        [reason]="shop.primaryUnbookableReasonFor(bookingParameters.start, bookingParameters.end)">
      </app-unbookable-info>
    } @placeholder {
      <div></div>
    }
  } @else {
    <app-proceed-to-product-list
      [shop]="shop"
      [bookingParameters]="bookingParameters"
      [adults]="adults"
      [children]="children"
      [isLoadingNewOutOfTownPriceData]="isLoadingNewOutOfTownPriceData"
      [isLoadingNewPriceData]="isLoadingNewPriceData"
      class="d-block mt-auto"
      [class.flex-grow-1]="this.resolutionService.isMobileDevice()" />
  }
</ng-template>
